import { render } from "./AIReviewPanel.vue?vue&type=template&id=2cde6826&scoped=true"
import script from "./AIReviewPanel.vue?vue&type=script&lang=js"
export * from "./AIReviewPanel.vue?vue&type=script&lang=js"

import "./AIReviewPanel.vue?vue&type=style&index=0&id=2cde6826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cde6826"]])

export default __exports__